var render = function render(_c,_vm){return _c('h3',{class:{ homme: _vm.props.profile.sex == 'MALE' }},[_vm._v(_vm._s(_vm.props.profile.pseudo)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }